import script from "./AuthenticatedLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=8a236c10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a236c10"]])

export default __exports__